import { render, staticRenderFns } from "./TabsDashboardPersonnel.vue?vue&type=template&id=73850786&"
import script from "./TabsDashboardPersonnel.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports